<script>
import Layout from "../../layouts/auth";

import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
// import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import {getScoreList2} from '@/api/user'
// import positionNegativeColor from '../../../../components/position-negative-color.vue';

/**
 * Starter component
 */
export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, },
  props: {
    updating1: {
      type: Boolean,
    },
    updating2: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      chartData: null,
      trade_perPage: 1,
      trade_pageOptions: [1, 3, 7, 15, 30],
      title: "",

      net_position_list: [],
      net_position_field: [
        {
          key: "create_time",
          sortable: true
        },
        {
          key: "user_name",
          sortable: true
        },
        {
          key: "id_card",
          sortable: true
        },
        {
          key: "model_score",
          sortable: true
        },
      ],
    };
  },
  filters: {
  },
  computed: {
 },

  methods: {
    get_net_position() {
        getScoreList2().then(res => {
        this.net_position_list = res
      }).catch(error => {
        console.log(error)
      })
    },
  },
  mounted() {
    console.log("hhhhhhhhhhhhh")
    this.get_net_position()
  },
  destroyed(){
            //console.log("销毁-----------------------之后");
        },
  beforeDestroy(){
    clearInterval(this.my_timer)
  }
};

</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="net_position_list"
                  :fields="net_position_field"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>